<ion-app>
  <ion-router-outlet main id="first"></ion-router-outlet>
  <section class="nt-container" *ngIf="loading">
    <div class="nt-loading-shade">
      <ion-spinner name="dots"></ion-spinner>
    </div>
  </section>
</ion-app>